import { render, staticRenderFns } from "./TextMedia.vue?vue&type=template&id=27e9949e&"
import script from "./TextMedia.vue?vue&type=script&lang=js&"
export * from "./TextMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports